export default __webpack_public_path__ + "static/media/facebook-logo.4a455df5.png";